import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import { notification, Button, Descriptions, Input, Popconfirm } from 'antd';

import FileUpload from 'components/common/FileController/FileUpload';
import FileDownload from 'components/common/FileController/FileDownload';
import Comment from "./Comment";

import "./QnaBoardDetail.scss";

class QnaBoardDetail extends Component {
  state = {
    saveData: {
      bodId: '',
      bodPw: '',
      bodTitle: '',
      bodContent: '',
      bodMakeUser: '',  //
      bodMakeDate: '',  //
      bodEditUser: '',  //
      bodEditDate: '',  //
      bodAttachedFile: '',
      bodAttachedList: []
    },
    commentsContent: ''
  };

  onChangValue = (dataVal, dataNm) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  setData = (mode) => {
    this.props.onViewMode(mode);
    if (mode === 'detail' || mode === 'add') {
      this.setState({
        saveData: {
          bodId: '',
          bodPw: '',
          bodTitle: '',
          bodContent: '',
          bodMakeUser: '',  //
          bodMakeDate: '',  //
          bodEditUser: '',  //
          bodEditDate: '',  //
          bodAttachedFile: '',
          bodAttachedList: [],
        },
        commentsContent: ''
    });
    } else if (mode === 'mod') {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.detailData
        },
        commentsContent: ''
      });
    }
  };

  onSave = () => {
    if (this.state.saveData.bodTitle === '') {
      notification.warning({placement: 'bottomLeft', message: `제목을 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.bodContent === '') {
      notification.warning({placement: 'bottomLeft', message: `내용을 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.bodPw.length < 4) {
      notification.warning({placement: 'bottomLeft', message: `비밀번호(숫자 4자리)를 입력해주세요.`, duration: 2});
      return false;
    }
    
    if (this.props.viewMode === 'add') {
      this.props.addQnaBoardInfo(this.state.saveData);
    } else if (this.props.viewMode === 'mod') {
      this.props.modQnaBoardInfo(this.state.saveData);
    }
  };

  onAttachedFile = (fileData) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        bodAttachedList: this.state.saveData.bodAttachedList.concat(fileData)
      }
    });
  };

  onRemove = (fileId) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        bodAttachedList: this.state.saveData.bodAttachedList.filter(element => element.fileId !== fileId)
    }});
  };

  // 댓글 저장
  addComments = () => {
    const { commentsContent } = this.state;
    if (commentsContent.length <= 0) {
      notification.warning({placement: 'bottomLeft', message: `댓글 내용을 입력해주세요.`, duration: 2});
      return false;
    }
    this.props.addQnaBoardCommentsInfo({commentsContent, commentsBodId: this.props.detailData?.bodId});
  }

  // 댓글 수정
  modComments = (data) => {
    this.props.modQnaBoardCommentsInfo({...data, commentsBodId: this.props.detailData?.bodId});
  }

  // 댓글 삭제
  delComments = (commentsId) => {
    this.props.delQnaBoardCommentsInfo({commentsId, commentsBodId: this.props.detailData?.bodId});
  }

  render() {
    const { viewMode, detailData, delQnaBoardInfo, sessionLoginInfo } = this.props;
    const { saveData, commentsContent } = this.state;
    return (
      <Fragment>
        <h2 className="h2_t">Q & A
        {viewMode === 'detail' && <Fragment> 상세보기</Fragment>}
        {viewMode === 'add' && <Fragment> 추가</Fragment>}
        {viewMode === 'mod' && <Fragment> 수정</Fragment>}
        </h2>
        <div className="board_btn_r">
        {((viewMode === 'detail')
        ? <Fragment>
            {/* 작성자만 수정가능 */}
            {(sessionLoginInfo?.ceCd === detailData?.bodMakeUser) &&
              <Fragment>
                <Button 
                  type="primary"
                  style={{marginRight: '5px'}}
                  onClick={()=>this.setData('mod')}
                >수정</Button>
                <Popconfirm 
                  title="삭제하시겠습니까?"
                  onConfirm={() => delQnaBoardInfo(detailData.bodId)}
                  onClick={(e)=>e.stopPropagation()}
                ><Button type="primary">삭제</Button>
                </Popconfirm>
              </Fragment>
            }
            <Button 
              type="primary"
              style={{marginLeft: '5px'}}
              onClick={()=>this.setData('list')}
            >목록</Button>
          </Fragment>
        : <Fragment>
            <Button 
              type="primary"
              style={{marginRight: '5px'}}
              onClick={()=>this.onSave()}
            >저장</Button>
            <Button 
              type="primary"
              onClick={()=>this.setData(viewMode === 'add' ? 'list' : 'detail')}
            >취소</Button>
          </Fragment>
        )}
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            {viewMode === 'detail' &&
            <Fragment>
              <Descriptions.Item label="NO">
                {detailData !== null && detailData.bodId !== undefined && detailData.bodId !== null && detailData.bodId}
              </Descriptions.Item>
              <Descriptions.Item label="작성일">
                {detailData !== null && detailData.bodMakeDate !== undefined && detailData.bodMakeDate !== null && detailData.bodMakeDate}
              </Descriptions.Item>
              <Descriptions.Item label="조회수">
                {detailData !== null && detailData.bodHit !== undefined && detailData.bodHit !== null && detailData.bodHit}
              </Descriptions.Item>
            </Fragment>
            }
            <Descriptions.Item label="제목" span={2}>
              {viewMode === 'detail'
              ? (detailData?.bodTitle || '')
              : <Input
                  value={saveData.bodTitle}
                  onChange={(e)=>this.onChangValue(e.target.value, 'bodTitle')}
                />
              }
            </Descriptions.Item>
            {viewMode === 'detail'
              ? <Fragment>
                  <Descriptions.Item label="작성자" span={1}>
                    {detailData?.bodMakeUserNm || ''}
                  </Descriptions.Item>
                </Fragment>
              : <Descriptions.Item label="비밀번호" span={1}>
                  <Input
                    placeholder={"비밀번호(숫자4자리)를 입력하세요."}
                    maxLength={4}
                    value={saveData?.bodPw || ''}
                    onChange={(e)=>{
                      const { value } = e.target;
                      const newValue = value.replace(/\D/g, ""); // 숫자 이외의 문자를 모두 제거
                      this.onChangValue(newValue, 'bodPw');
                  }}/>
                </Descriptions.Item>
            }
            <Descriptions.Item label="내용" span={3}>
              {viewMode === 'detail'
              ? (detailData !== null && detailData.bodContent !== undefined && detailData.bodContent !== null && detailData.bodContent) &&
                <div className="min-hight-150">
                  {detailData.bodContent.split(`\n`).map((item, idx)=>{
                    return (
                      <Fragment key={idx}>
                        {item}
                        {detailData.bodContent.split(`\n`).length > idx+1 && <br />}
                      </Fragment>
                  )})}
                </div>
              : <Input.TextArea className="height-300" 
                  autoSize={true}
                  value={saveData.bodContent}
                  onChange={(e)=>this.onChangValue(e.target.value, 'bodContent')}                 
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="첨부파일" span={3}>
              {viewMode === 'detail'
              ? (detailData?.bodAttachedList) &&
                <FileDownload
                  fileInfoList={[...detailData.bodAttachedList]}
                />
              : <Fragment>
                  <FileUpload
                    onFileInfo={(fileData)=>this.onAttachedFile(fileData)}
                  />
                  {saveData?.bodAttachedList &&
                    saveData.bodAttachedList.map((item,idx)=>{
                    return(
                      <Fragment key={idx}>
                        {item.fileName !== undefined && item.fileName !== null && item.fileName}
                        <span
                          style={{ margin: 10, color: 'red' }}
                          onClick={()=>this.onRemove(item.fileId)}
                        >X</span>
                        {idx !== saveData.bodAttachedList.length && <br />}
                      </Fragment>
                    );
                  })}
                </Fragment>
              }
            </Descriptions.Item>
            
          </Descriptions>
        </div>

        {viewMode === 'detail' && detailData &&
          <div className='Comment_div'>
            {/* 댓글 리스트 컴포넌트 */}
            {detailData?.commentsList &&
              detailData.commentsList.map((item,idx)=>{
              return(
                <Comment 
                  key={idx} 
                  commentsData={item}
                  sessionLoginInfo={sessionLoginInfo}
                  modComments={this.modComments}
                  delComments={this.delComments}
                />
              );
            })}
            <div className='Comment_write_div'>
              <Input.TextArea 
                className='height-100 Comment_write'
                autoSize={true}
                value={commentsContent}
                onChange={(e)=>this.setState({commentsContent: e.target.value})}                 
              />
              <Button 
                className='Comment_submit_button'
                onClick={this.addComments}
              >등록</Button>
            </div>
          </div>
        }
      </Fragment>
    );
    
  }
}

export default withRouter(QnaBoardDetail);
